import { queryOptions, useQuery } from '@tanstack/react-query';
import { flattenJurisdictions, getJurisdictions, toCountryList } from '@/services/api/jurisdictions';

export const JURISDICTIONS_QUERY_KEY = ['compliance', 'jurisdictions'] as const;

export const jurisdictionsQueryOptions = () =>
  queryOptions({
    queryKey: JURISDICTIONS_QUERY_KEY,
    queryFn: getJurisdictions,
    select: flattenJurisdictions,
  });

export const useJurisdictions = () => useQuery(jurisdictionsQueryOptions());

/** Same cache entry as `useJurisdictions`, selected as the `countries` fast-api-domain's form schemas take */
export const useCountryList = () => useQuery({ ...jurisdictionsQueryOptions(), select: toCountryList });
